<template>
    <div
        class="modal login-form-popup fade h-auto"
        id="forgotpassword"
        tabindex="-1"
        aria-labelledby="forgotpassword"
        aria-hidden="true"
        data-keyboard="false"
        data-backdrop="static"
    >
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
            <div class="modal-content">
                <div class="modal-body">
                    <a
                        href="#"
                        class="popup-close"
                        id="reset-popup-close"
                        data-dismiss="modal"
                    >
                        <img src="/maincss/images/cancel.svg" alt=" " />
                    </a>
                    <div class="login-form">
                        <h3>Forgot Password</h3>
                        <p>Send a Reset Password Link!</p>
                        <form
                            method="post"
                            @submit.prevent="onSubmitToResetPassword"
                            data-vv-scope="resetform"
                            :key="'resetform'"
                        >
                            <div class="form-group">
                                <input
                                    type="text"
                                    class="form-control"
                                    id="Email"
                                    name="email"
                                    v-model="resetform_data.email"
                                    v-validate="'required|email'"
                                />
                                <label>Email ID</label>
                                <span class="highlight"></span>
                                <span class="bar"></span>
                                <small
                                    class="form-text text-error text-left"
                                    v-show="errors.has('resetform.email')"
                                >
                                    {{ errors.first("resetform.email") }}
                                </small>
                            </div>
                            <button
                                type="submit"
                                class="btn btn_orange bg_primary_orange text_white w-100 mt_34 mb_32 btn_h60"
                            >
                                Reset
                            </button>
                            <div class="d-md-flex">
                                <p class="small ml-auto">
                                    <a
                                        href="#"
                                        class="btn-link login-cart"
                                        data-path="/MyAccount"
                                        data-toggle="modal"
                                        data-target="#login"
                                        data-dismiss="modal"
                                        >Login</a
                                    >
                                </p>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ApiService from "@/common/api.service";

export default {
    name: "forgot-password-modal",
    props: [],
    data() {
        return {
            isLoader: false,
            sitekey: "6LeO510lAAAAAEo-dFZ50cbrWaS4gRPnEqFi-_X3", // OLD KEY: 6Ld8A1IgAAAAAC5RTdjFW82Y_RYAbVrNVltIaoLe
            recaptcha: null,
            captchaErrMsg: true,
            resetform_data: {
                email: null
            }
        };
    },
    components: {},
    computed: {},
    watch: {},
    mounted() {},
    methods: {
        verifyCaptcha(response) {
            this.recaptcha = response;
            if (this.recaptcha) {
                this.captchaErrMsg = false;
            }
        },
        onCaptchaExpired() {
            this.$refs.recaptcha.reset();
        },
        onSubmitToResetPassword() {
            var _this = this;
            _this.$validator.validateAll("resetform").then((isValid) => {
                if (isValid) {
                    new Promise(() => {
                        ApiService.post(
                            "/forgot-password",
                            _this.resetform_data
                        )
                            .then(({ data }) => {
                                if (data.success) {
                                    _this.$toast.success(
                                        "Reset Password link sent successfully.",
                                        { position: "top-right" }
                                    );
                                    document
                                        .getElementById("reset-popup-close")
                                        .click();
                                } else {
                                    _this.errors.itemslength = 0;
                                    _this.errors.items.push({
                                        id: 1,
                                        vmId: _this.errors.vmId,
                                        field: "email",
                                        msg: data.error,
                                        scope: "resetform"
                                    });
                                }
                            })
                            .catch(({ response }) => {
                                console.log(response);
                                _this.errors.itemslength = 0;
                                _this.errors.items.push({
                                    id: 1,
                                    vmId: 3,
                                    field: "email",
                                    msg: response.data.error,
                                    scope: "resetform"
                                });
                                console.log("exception", response.data.error);
                            });
                    });
                } else {
                    console.log("form error", _this.errors);
                }
            });
        }
    }
};
</script>
